
const firebaseConfig = {
    apiKey: "AIzaSyBkx2OXdbBaKqBATHwAT-7gK4cxKT_Q_AU",
    authDomain: "medical-project-faa8f.firebaseapp.com",
    projectId: "medical-project-faa8f",
    storageBucket: "medical-project-faa8f.appspot.com",
    messagingSenderId: "362369229569",
    appId: "1:362369229569:web:63b723cd12455ffbd73100"
  };

export default firebaseConfig;